const classNames = (...args: (string | boolean)[]) => {
  return args
    .filter(s => typeof s === 'string')
    .filter(Boolean)
    .join(' ');
};

export default classNames;
